import React from 'react';
import FeatureCards from "../../components/FeatureCards/FeatureCards";
import CTA from "../../components/Constant/cta/CTA";
import TimelineSection from "../../components/TimelineSection/TimelineSection";
import WhySection from "../../components/WhySection/WhySection";
import LocationTimeline from "../../components/LocationTimeline/LocationTimeline";
import IntroSection from "../../components/IntroSection/IntroSection";
import FAQList from "../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../components/ServiceCards/ServiceCards ";

export default function FintechServices() {

    return (
        <main className='main'>
            <IntroSection
                title="FinTech Services"
                subtitle="Licensing, Compliance & Infrastructure for Global Fintechs"
                description="At Offshore Advisory, we provide end-to-end licensing, compliance, and technical support for launching and scaling fintech businesses. Whether you’re building a neobank, PSP, crypto exchange, digital wallet, or payment platform, we deliver everything you need—from regulatory approvals to software infrastructure and banking integration."
                badges={[
                    "EMI & PI Licensing",
                    "Crypto & DLT Registration",
                    "Compliance & KYC",
                    "Banking & PSP Setup"
                ]}
                buttonText="Request a Fintech Consultation →"
                buttonLink="/quote"
                imageSrc={require('../../assets/images/fintech-services/fintech-services.png')}
                imageAlt="FinTech Licensing & Services"
            />


            <section className='section'>
                <div className="container">
                    <WhySection
                        title="Fintech Licensing Support"
                        subtitle="We assist in obtaining fintech licenses across multiple jurisdictions, including:"
                        blocks={[
                            {
                                items: [
                                    { title: "Electronic Money Institution (EMI) License", text: "For wallets, prepaid cards, mobile banking platforms. SEPA/SWIFT enabled accounts, IBAN issuance. Jurisdictions: Lithuania, UK, Malta, Mauritius, Anjouan." },
                                    { title: "Payment Institution (PI) License", text: "For remittance services, PSPs, payment gateways. Merchant account + POS integration. Jurisdictions: Cyprus, Malta, Lithuania, UAE." },
                                    { title: "Money Services Operator (MSO)", text: "For money transfer, currency exchange, and crypto-fiat gateways. Jurisdictions: Hong Kong, Mwali, Anjouan." },
                                    { title: "Stored Value Facility (SVF)", text: "For prepaid platforms & wallet solutions. Jurisdictions: Hong Kong, Mauritius." },
                                    { title: "Distributed Ledger Technology (DLT) License", text: "For blockchain, token issuance, and crypto operations. Jurisdictions: Gibraltar, Seychelles, Western Sahara (CRASADR)." },
                                    { title: "Crypto Exchange / Wallet License", text: "For exchanges, custody, and trading. Includes AML/KYC setup and VASP registration. Jurisdictions: Mwali, Mauritius, Estonia, Western Sahara." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Compliance & Advisory"
                        subtitle='We design and implement compliance frameworks to meet international standards:'
                        blocks={[
                            {
                                items: [
                                    { text: "AML/CFT policies (FATF-based)." },
                                    { text: "KYC onboarding (manual & automated)." },
                                    { text: "Internal risk control systems." },
                                    { text: "Appointment of compliance officer / MLRO." },
                                    { text: "Regulatory filings, audits, and reporting." },
                                    { text: "Whitepapers and legal opinions for crypto, ICO, or STO." }
                                ]
                            }
                        ]}
                    />

                    <WhySection
                        title="Technical & Banking Integration"
                        subtitle='We provide the infrastructure and partnerships fintechs need to operate globally:'
                        blocks={[
                            {
                                items: [
                                    { text: "White-label banking & wallet platforms (web + mobile)." },
                                    { text: "Crypto exchange software (trading engines, custody, wallets)." },
                                    { text: "Payment gateway integration (API + sandbox testing)." },
                                    { text: "Fraud detection, AML monitoring, and transaction screening." },
                                    { text: "Corporate & EMI bank account setup." },
                                    { text: "PSP partnerships across EU, MENA, and Asia." }
                                ]
                            }
                        ]}
                    />

                    <InfoBlocks
                        title="Launch & Expansion Roadmap"
                        subtitle='Our consultants guide you through every step:'
                        blocks={[
                            {
                                items: [
                                    { text: "Business model design." },
                                    { text: "Jurisdiction & license selection." },
                                    { text: "Company incorporation." },
                                    { text: "Application preparation & filing." },
                                    { text: "Operational readiness: staffing, audit, training." },
                                    { text: "Banking + PSP integration." }
                                ]
                            }
                        ]}
                    />

                    <ServiceCards
                        title="Ideal Use Cases"
                        services={[
                            { title: "Digital Banks (Neobanks)", text: "" },
                            { title: "Payment Aggregators & PSPs", text: "" },
                            { title: "Cross-Border Remittance Platforms", text: "" },
                            { title: "Crypto Wallets & Exchanges", text: "" },
                            { title: "B2B Banking-as-a-Service Providers", text: "" },
                            { title: "Tokenized Investment & Crowdfunding Platforms", text: "" }
                        ]}
                    />

                    <WhySection
                        title="Top Jurisdictions for FinTech Launches"
                        blocks={[
                            {
                                items: [
                                    { text: "Lithuania — EU EMI/PI licenses, SEPA access." },
                                    { text: "Malta — Crypto + EMI licensing with EU credibility." },
                                    { text: "Mauritius — Cost-effective fintech licenses, Africa/Asia access." },
                                    { text: "Cyprus — PI + investment services." },
                                    { text: "Mwali / Anjouan — Quick & affordable fintech licensing." },
                                    { text: "Western Sahara (CRA) — DLT, crypto, EMI via CRASADR." },
                                    { text: "Estonia — Crypto & VASP licenses (pending regulations)." },
                                    { text: "UAE (DIFC, ADGM) — Fintech sandboxes and regulated PSPs." }
                                ]
                            }
                        ]}
                    />

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>

                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />

                    <CTA
                        title="Ready to launch your fintech business?"
                        description="From licensing to compliance, software, and banking, Offshore Advisory delivers turnkey solutions."
                        buttonText="Book a Free Fintech Consultation →"
                        buttonLink="/quote"
                    />

                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "Which fintech license do I need for a crypto exchange?",
        answer: "You may need a Crypto Exchange / VASP license and potentially an EMI license for fiat on/off ramp.",
    },
    {
        question: "How long does licensing take?",
        answer: "Fast-track offshore (Mwali, Anjouan, Western Sahara): 2–6 weeks. EU jurisdictions (Lithuania, Malta, Cyprus): 3–6 months.",
    },
    {
        question: "What’s the cost of an EMI/PSP license?",
        answer: "Depends on jurisdiction: entry packages start from USD 20,000–50,000.",
    },
    {
        question: "Do I also need a bank account?",
        answer: "Yes — we provide introductions to EMI banks, PSPs, and crypto-friendly banking partners.",
    },
    {
        question: "Can you also provide software?",
        answer: "Yes, we deliver white-label solutions for banking, wallets, and crypto exchanges.",
    },
];

const testimonialsData = [
    {
        quote: "Offshore Advisory helped us secure an EMI license in Lithuania and connect with SEPA partners. Their compliance team was top class.",
        author: "Elena P.",
        role: "FinTech Founder"
    },
    {
        quote: "We launched our crypto exchange in Mauritius within 8 weeks thanks to Offshore Advisory’s licensing and technical setup.",
        author: "Daniel T.",
        role: "Crypto Entrepreneur"
    }
];
